'use client'

import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import Cookies from "js-cookie";
import {COOKIE_DATA} from "@/components/providers/appContext/types";
import {updateGlobalLoading} from "@/redux/slices/settings";
import {useDispatch} from "react-redux";
import {useRouter} from "next/navigation";

const Page = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const [mess, setMess] = useState<string>("")
    useEffect(() => {
        const value: string = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_PREFIX + "_SITE_DATA");
        if (value) {
            const cookieData: COOKIE_DATA = JSON.parse(value);
            if(cookieData?.context?.webContext?.indexPage) {
                dispatch(updateGlobalLoading(true));
                router.push(cookieData.context.webContext.indexPage);
                return;
            }
        }
        setMess("Invalid route")
    }, [])

    return <Grid container sx={{width: "100%"}}>
        {mess}
    </Grid>
}

export default Page;